export default __webpack_public_path__ + "static/media/kate_sawin.c0975583.jpg";